<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-advanced-contact"
      size="xl"
      scrollable
      centered
      button-size="sm"
      @hidden="onReset"
    >
      <template #modal-title>
        <i class="fas fa-user"></i> ADICIONAR CONTATOS AVANÇADOS
      </template>
      <div class="pl-3 pr-3">
        <div class="form-group row">
          <div class="col-md-3">
            <label>
              <small
                class="text-danger"
                v-if="form.tipoPessoa.required"
                >*</small
              >
              Tipo Pessoa:
            </label>
            <v-select
              multiple
              v-model="form.tipoPessoa.value"
              :options="form.tipoPessoa.options"
              :reduce="(x) => x.value"
              class="w-100"
              label="text"
              placeholder="Selecione o Tipo de Pessoa"
            >
              <template v-slot:no-options>{{
                $lang.Common.PlaceholderSelect
              }}</template>
            </v-select>
          </div>
          <div class="col-md-3">
            <label>
              <small
                class="text-danger"
                v-if="form.document.required"
                >*</small
              >
              Documento:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o CPF ou CNPJ'"
                v-model="form.document.value"
                :size="form.document.maxlength"
                :required="form.document.required"
                :state="form.document.state"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label
              ><small
                class="text-danger"
                v-if="form.numId.required"
                >*</small
              >
              {{ $t('associates.number') }}:</label
            >
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="`Digite o ${$t('associates.number')}`"
                v-model="form.numId.value"
                :size="form.numId.maxlength"
                :required="form.numId.required"
                :state="form.numId.state"
              ></b-form-input>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-8">
            <label
              ><small
                class="text-danger"
                v-if="form.nomeAssociado.required"
                >*</small
              >
              Nome do Associado:</label
            >
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o Nome do Associado'"
                v-model="form.nomeAssociado.value"
                :size="form.nomeAssociado.maxlength"
                :required="form.nomeAssociado.required"
                :state="form.nomeAssociado.state"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.numeroPA.required"
                >*</small
              >
              PA:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.numeroPA.value"
                :options="form.numeroPA.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o PA"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
        </div>

        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.gerenteId.required"
                >*</small
              >
              {{ $t('associates.gerenteSisbr') }}:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.gerenteId.value"
                :options="form.gerenteId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                :placeholder="`Selecione o ${$t('associates.gerenteSisbr')}`"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.gerenteRelacionamentoId.required"
                >*</small
              >
              Agente de Relacionamento:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.gerenteRelacionamentoId.value"
                :options="form.gerenteRelacionamentoId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Agente de Relacionamento"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.clusterizacaoId.required"
                >*</small
              >
              Clusterização:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.clusterizacaoId.value"
                :options="form.clusterizacaoId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Cluster"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
        </div>

        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.regionalId.required"
                >*</small
              >
              Regional:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.regionalId.value"
                :options="form.regionalId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione a Regional"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.grupoEconomico.required"
                >*</small
              >
              Grupo Econômico:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite Nome do Grupo Econômico'"
                v-model="form.grupoEconomico.value"
                :size="form.grupoEconomico.maxlength"
                :required="form.grupoEconomico.required"
                :state="form.grupoEconomico.state"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.pendencias.required"
                >*</small
              >
              Pendências:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.pendencias.value"
                :options="form.pendencias.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione a Pendência"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
        </div>

        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.statusContaCorrente.required"
                >*</small
              >
              Status da Conta Corrente:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.statusContaCorrente.value"
                :options="form.statusContaCorrente.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Status da Conta Corrente"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.statusMatricula.required"
                >*</small
              >
              Status da Conta Capital:
            </label>
            <div class="input-group">
              <v-select
                multiple
                v-model="form.statusMatricula.value"
                :options="form.statusMatricula.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Status da Conta Capital"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label> Faixa de Renda:</label>
            <div class="input-group">
              <money
                :placeholder="$lang.Currency.Placeholder"
                class="form-control text-bold"
                max-length="12"
                v-model.lazy="rendaInicial"
                v-bind="$lang.Currency.Format"
              ></money>
              <money
                :placeholder="$lang.Currency.Placeholder"
                class="form-control text-bold"
                max-length="12"
                v-model.lazy="rendaFinal"
                v-bind="$lang.Currency.Format"
              ></money>
            </div>
          </div>
        </div>

        <div class="form-group row pt-2">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-3">
                <label> Faixa de Relacionamento Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialInicioRelacionamento.value"
                  :required="form.dataInicialInicioRelacionamento.required"
                  :state="form.dataInicialInicioRelacionamento.state"
                />
              </div>

              <div class="col-md-3">
                <label> Faixa de Relacionamento Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalInicioRelacionamento.value"
                  :required="form.dataFinalInicioRelacionamento.required"
                  :state="form.dataFinalInicioRelacionamento.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data de Nascimento/Abertura Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicioNascimentoOuAbertura.value"
                  :required="form.dataInicioNascimentoOuAbertura.required"
                  :state="form.dataInicioNascimentoOuAbertura.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data de Nascimento/Abertura Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalNascimentoOuAbertura.value"
                  :required="form.dataFinalNascimentoOuAbertura.required"
                  :state="form.dataFinalNascimentoOuAbertura.state"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row pt-3 pb-3">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-third btn-sm"
              v-b-tooltip.hover
              :title="'Pesquisar'"
              @click.prevent="onSearch"
            >
              <i class="fas fa-search"></i>
              <span class="d-md-down-none"> Pesquisar</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-sm text-secundary"
              v-on:click="onClear"
              v-b-tooltip.hover
              :title="$lang.Common.Tooltip.ButtonClear"
            >
              <i class="fa fa-minus-circle"></i>
              <span class="d-md-down-none">
                {{ $lang.Common.Buttons.Clear }}</span
              >
            </button>
          </div>
        </div>

        <Tables
          ref="tableGridAdv"
          :columns="[
            $t('associates.abreviacaoNumber'),
            'CPF/CNPJ',
            'Nome',
            'E-mail',
            'Celular'
          ]"
          :showTipFooter="false"
          :showHeader="true"
          v-on:Load="onSearch"
        >
          <tr
            v-for="(obj, index) in this.objList"
            v-bind:key="index"
          >
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.numId.toString()"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.document"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.name ? obj.name.toUpperCase() : ''"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.email"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.telefone"
            />
          </tr>
        </Tables>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Adicionar'"
            @click="onCreate"
          >
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Adicionar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'
import ListaContatoRepository from '@/shared/http/repositories/configurations/listacontato.js'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import RegionalRepository from '@/shared/http/repositories/configurations/regional.js'

import NxDatePicker from '@/components/forms/NxDatePicker.vue'

const AdvancedContactData = {
  tipoPessoa: null,
  document: null,
  numId: null,
  nomeAssociado: null,
  numeroPA: null,
  gerenteId: null,
  gerenteRelacionamentoId: null,
  clusterizacaoId: null,
  regionalId: null,
  grupoEconomico: null,
  pendencias: null,
  statusContaCorrente: null,
  statusMatricula: null,
  rendaInicial: null,
  rendaFinal: null,
  dataInicialInicioRelacionamento: null,
  dataFinalInicioRelacionamento: null,
  dataInicioNascimentoOuAbertura: null,
  dataFinalNascimentoOuAbertura: null
}

const AdvancedContactForm = {
  tipoPessoa: {
    value: null,
    options: [
      { text: 'Pessoa Física', value: 'PF' },
      { text: 'Pessoa Jurídica', value: 'PJ' }
    ],
    required: false,
    state: null
  },
  document: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numId: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  nomeAssociado: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numeroPA: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gerenteId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gerenteRelacionamentoId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  clusterizacaoId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  regionalId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  grupoEconomico: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  pendencias: {
    value: null,
    options: [
      { text: 'Ajuizado', value: 'AJUIZADO' },
      { text: 'Cobrança', value: 'COBRANCA' },
      { text: 'Impeditiva Absoluta', value: 'IMPEDITIVA_ABSOLUTA' },
      { text: 'Protestado', value: 'PROTESTADO' }
    ],
    required: false,
    state: null
  },
  statusContaCorrente: {
    value: null,
    options: [
      { text: 'Ativa', value: 'ATIVA' },
      { text: 'Ativa Bloqueada', value: 'ATIVA BLOQUEADA' },
      {
        text: 'Ativa Bloqueada Judicialmente',
        value: 'ATIVA BLOQUEADA JUDICIALMENTE'
      },
      { text: 'Inativa', value: 'INATIVA' },
      { text: 'Inativa Bloqueada', value: 'INATIVA BLOQUEADA' },
      {
        text: 'Inativa Bloqueada Judicialmente',
        value: 'INATIVA BLOQUEADA JUDICIALMENTE'
      },
      { text: 'Não Informado', value: 'NAO INFORMADO' }
    ],
    required: false,
    state: null
  },
  statusMatricula: {
    value: null,
    options: [
      { text: 'Ativo', value: 'ATIVO' },
      { text: 'Demitido', value: 'DEMITIDO' },
      { text: 'Eliminado', value: 'ELIMINADO' },
      { text: 'Excluído', value: 'EXCLUÍDO' }
    ],
    required: false,
    state: null
  },
  dataInicialInicioRelacionamento: {
    value: '',
    required: false,
    state: null
  },
  dataFinalInicioRelacionamento: {
    value: '',
    required: false,
    state: null
  },
  dataInicioNascimentoOuAbertura: {
    value: '',
    required: false,
    state: null
  },
  dataFinalNascimentoOuAbertura: {
    value: '',
    required: false,
    state: null
  }
}

export default {
  name: 'ModalSegmentAdvancedContactAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: AdvancedContactData,
      form: AdvancedContactForm,
      rendaInicial: 0,
      rendaFinal: 0,
      campanhaListaId: null,
      filters: null,
      selected: [],
      selectAll: false,
      persons: []
    }
  },
  components: {
    NxDatePicker
  },
  methods: {
    onLoad () {
      this.onClear()
    },
    onClear () {
      this.onReset()
    },
    showModal (campanhaListaId) {
      this.$refs['modal-advanced-contact'].show()

      this.$nextTick(() => {
        this.onReset()
        this.onLoadAllEmployees()
        this.onLoadAllPAs()
        this.onLoadAllCluster()
        this.onLoadAllRegional()
        this.campanhaListaId = campanhaListaId
      })
    },
    hideModal () {
      this.onReset()
      this.$refs['modal-advanced-contact'].hide()
      this.$emit('created')
    },
    onLoadAllEmployees () {
      EmployeeRepository.GetAll()
        .then((response) => {
          const funcionariosOptionList = response.data.content
            .filter((x) => x.usuarioId != null)
            .map((x) => ({ value: x.id, text: x.pessoa.nome }))

          this.form.gerenteId.options = funcionariosOptionList
          this.form.gerenteRelacionamentoId.options = funcionariosOptionList
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllPAs () {
      PARepository.GetAll()
        .then((response) => {
          this.form.numeroPA.options = response.data.content.map((x) => ({
            value: x.numero,
            text: x.descricao
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllCluster () {
      ClusterRepository.GetAll()
        .then((response) => {
          this.form.clusterizacaoId.options = response.data.content.map(
            (x) => ({ value: x.id, text: x.descricao })
          )
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllRegional () {
      RegionalRepository.GetAll()
        .then((response) => {
          this.form.regionalId.options = response.data.content.map((x) => ({
            value: x.id,
            text: x.nome
          }))
        })
        .catch((err) => this.onException(err))
    },
    onReset () {
      Tools.ClearDataForms(this.form, this.data)
      this.campanhaListaId = null
      this.persons = []
      this.selected = []
      this.selectAll = false
      this.objList = []
      this.rendaInicial = 0
      this.rendaFinal = 0
      this.$refs.tableGridAdv && this.$refs.tableGridAdv.Clear()
    },
    onSearch () {
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        loading.push()

        if (this.data.document) {
          let document = this.data.document
            .replaceAll('-', '')
            .replaceAll('.', '')
            .replaceAll('/', '')
          this.data.document = document
        }

        if (this.rendaInicial && this.rendaInicial > 0) {
          this.data.rendaInicial = this.rendaInicial
        }
        if (this.rendaFinal && this.rendaFinal > 0) {
          this.data.rendaFinal = this.rendaFinal
        }

        let filters = Tools.getFilters(this.data)

        AssociateRepository.SearchCampanhaLista(
          filters,
          this.$refs.tableGridAdv.pagingLimit,
          this.$refs.tableGridAdv.pagingIndex
        )
          .then((response) => {
            this.onResultGrid(this.gridData(response), this.$refs.tableGridAdv)
          })
          .catch(this.onException)
      }
    },
    select () {
      if (!this.selectAll) {
        for (let i in this.objList) {
          this.selected.push(this.objList[i])
        }
      }
    },
    onCreate () {
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        loading.push()

        if (this.data.document) {
          let document = this.data.document
            .replaceAll('-', '')
            .replaceAll('.', '')
            .replaceAll('/', '')
          this.data.document = document
        }

        if (this.rendaInicial && this.rendaInicial > 0) {
          this.data.rendaInicial = this.rendaInicial
        }
        if (this.rendaFinal && this.rendaFinal > 0) {
          this.data.rendaFinal = this.rendaFinal
        }

        ListaContatoRepository.ImportWithFilterCampanha(
          this.campanhaListaId,
          this.data
        )
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              loading.pop()
              this.hideModal()
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      }
    },
    gridData (response) {
      let returnValue = []
      if (
        response.data &&
        response.data.content &&
        response.data.content.length > 0
      ) {
        response.data.content.forEach((i) => {
          const pessoa = i.pessoa || {}
          const telefones = pessoa.telefone || []

          // Filtrar apenas celulares
          const celulares = telefones.filter(
            (contato) => contato.tipoContato === 'CELULAR'
          )

          // Remover duplicados: manter apenas telefones com números únicos (comparando apenas dígitos)
          const telefonesUnicos = celulares.reduce((acc, celular) => {
            const numeroLimpo = (celular.telefone || '').replace(/\D/g, '')
            const jaExiste = acc.some(t => t.numeroLimpo === numeroLimpo)
            if (!jaExiste && numeroLimpo) {
              acc.push({
                telefone: celular.telefone,
                numeroLimpo: numeroLimpo
              })
            }
            return acc
          }, [])

          // Se tem telefones únicos, criar uma linha para cada um
          if (telefonesUnicos.length > 0) {
            telefonesUnicos.forEach(tel => {
              returnValue.push({
                numId: i.numId ? i.numId : '',
                document: pessoa.document || '',
                name: pessoa.nome || '',
                email: pessoa.email || '',
                telefone: tel.telefone
              })
            })
          } else {
            // Se não tem telefone, retorna uma linha sem telefone
            returnValue.push({
              numId: i.numId ? i.numId : '',
              document: pessoa.document || '',
              name: pessoa.nome || '',
              email: pessoa.email || '',
              telefone: ''
            })
          }
        })
      }
      response.data.content = returnValue
      return response
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/campaignlist/components/add/modal/advancedcontactmodal/advancedcontact.vue